import { TimePair, TimePairsByWeekday, Weekday } from './types';

export const DEFAULT_TIME_PAIR: TimePair = {
  endMinutes: 24 * 60,
  startMinutes: 0,
};

export const WEEKDAYS: Weekday[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const DEFAULT_WEEKLY_SCHEDULE: TimePairsByWeekday = {
  monday: [DEFAULT_TIME_PAIR],
  tuesday: [DEFAULT_TIME_PAIR],
  wednesday: [DEFAULT_TIME_PAIR],
  thursday: [DEFAULT_TIME_PAIR],
  friday: [DEFAULT_TIME_PAIR],
  saturday: [DEFAULT_TIME_PAIR],
  sunday: [DEFAULT_TIME_PAIR],
};

export const daysOfWeek = {
  monday: { id: 'week.mon', default: 'Monday' },
  tuesday: { id: 'week.tue', default: 'Tuesday' },
  wednesday: { id: 'week.wed', default: 'Wednesday' },
  thursday: { id: 'week.thu', default: 'Thursday' },
  friday: { id: 'week.fri', default: 'Friday' },
  saturday: { id: 'week.sat', default: 'Saturday' },
  sunday: { id: 'week.sun', default: 'Sunday' },
};

export const daysOfWeekShort = {
  monday: { id: 'week-short.mon', default: 'Mon' },
  tuesday: { id: 'week-short.tue', default: 'Tue' },
  wednesday: { id: 'week-short.wed', default: 'Wed' },
  thursday: { id: 'week-short.thu', default: 'Thu' },
  friday: { id: 'week-short.fri', default: 'Fri' },
  saturday: { id: 'week-short.sat', default: 'Sat' },
  sunday: { id: 'week-short.sun', default: 'Sun' },
};
